export const environment = {
	production: true,
	primeLicense: 'eyJpZCI6IjI1N2ZlNzVhLTRkYmYtNGFmYS1hYTEzLTlmNmU0MDIxZGIwOCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3OTE4OTEyNjgsImV4cCI6MTgyMzQyNzI2OH0.pgts_G9n81ek7PoOiBt-dDrFXApXsffYWsdF8tk7jq8tmlGho6Leep7JI5tco4yL5vJtJpWaho0wMYdFOi2CAA',
	apiUrl: '/api/',
    apiOfficeware:'/api/',
	apiDownload: 'https://dev-files.plenion247.eu',
	apiUrlHost: 'https://dev-id.plenion247.eu',
	apiDomain: 'https://desarrollo-api.plenion247.eu/api/domain/v1',
	version: '0.0.1',
	firebase: {
		apiKey: 'AIzaSyBhvyWGz1PnCl-12IkXBQ9dU2ejBkuliWk',
		authDomain: 'dev-plenion-portal.firebaseapp.com',
		databaseURL: 'https://dev-plenion-portal.firebaseio.com',
		projectId: 'dev-plenion-portal',
		storageBucket: 'dev-plenion-portal.appspot.com',
		messagingSenderId: '268340926695',
		appId: '1:268340926695:web:75d6ebc9244035c4452a42',
	},
};
